import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SmsValidationService } from '../../services/sms-validation/sms-validation.service';
import { Router } from '@angular/router';
import { TranslationsService } from '../../services/translations/translations.service';
import { UserService } from '../../services/user/user.service';
import { NgForm } from '@angular/forms';
import { TextControl } from '../../models/controls/text-control';
import {
  Success,
  SuccessResponse,
} from '../../models/intefaces/success-response';
import { ConfirmationRouteName } from '../../models/constants';

const HiddenCharCount = 6;

@Component({
  selector: 'app-sms-validation',
  templateUrl: './sms-validation.component.html',
  styleUrls: ['./sms-validation.component.scss'],
})
export class SmsValidationComponent implements OnInit, AfterViewInit {
  @ViewChild('formElement')
  formElement?: NgForm;

  readonly control = new TextControl('sms', 'sms.code');

  isValid = false;

  constructor(
    private readonly smsValidationService: SmsValidationService,
    private readonly translationsService: TranslationsService,
    private readonly userService: UserService,
    private readonly router: Router
  ) {}

  getText(): string {
    const smsText = this.translationsService.getValue('sms.text');
    return smsText.replace('{mobile}', this.maskSMS());
  }

  ngOnInit(): void {
    this.smsValidationService.send().subscribe();
  }
  ngAfterViewInit(): void {
    this.formElement?.statusChanges?.subscribe(
      () => (this.isValid = this.formElement?.valid || false)
    );
  }

  validate(): void {
    if (this.isValid) {
      this.smsValidationService
        .validate(this.control.value || '')
        .subscribe((response: SuccessResponse) => {
          if (response.success === Success) {
            this.userService.reset();
            this.router.navigate([
              this.translationsService.getCurrentLanguage(),
              ConfirmationRouteName,
            ]);
          }
        });
    }
  }

  sendAgain(): void {
    this.smsValidationService.send().subscribe();
  }

  back(): void {}

  canGoNext(): boolean {
    return this.isValid;
  }

  private maskSMS(): string {
    const mobile = this.userService.getLastOrder().mobile;
    let maskedMobile = mobile.substr(0, 3);
    for (let i = 0; i < mobile.length - HiddenCharCount; i++) {
      maskedMobile += '*';
    }
    maskedMobile += mobile.substr(mobile.length - 3);
    return maskedMobile;
  }
}
